<template>
  <div class="my-2">
    <div v-for="(form, key) in target[prop]" :key="key" class="mb-3">
      <div class="col">
        <div class="form-group">
          <div class="row">
            <div class="col-sm-12 col-md-6">
              <label class="mb-1">
                Firmado #{{ key + 2 }}<span class="color-req">*</span>
              </label>
            </div>
            <div class="col-sm-12 col-md-6">
              <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
                <button
                type="button"
                class="btn btn-danger btn-clock btn-with-shadow"
                @click="remove(key)"
              >
                Eliminar <i class="fa fa-trash"></i>
              </button>
              </div>
            </div>
          </div>
          <quill-editor
            v-model="target[prop][key].signature"
            :options="editorOption"
          />
          <small v-if="false" class="color-txt">Este campo es obligatorio</small>
        </div>
      </div>
    </div>

    <button type="button" class="btn btn-primary" @click="addEvaluators()">
      Añadir Firma
    </button>
  </div>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import { ModalMixin } from "@/app/Mixins/ModalMixin";
import { quillEditor } from "vue-quill-editor";
import { axiosGet } from "@/app/helpers/AxiosHelper";
export default {
  name: "DynamicSignature",
  mixins: [FormMixin, ModalMixin],
  components: { quillEditor },
  props: {
    titleva: String,
    model: Object,
    self: String,
    auxsig: Array,
  },
  watch: {
  auxsig(newValue) {
    this.DataSignatures();
  }
},
  data() {
    return {
      target: this.model,
      prop: this.self,
      auxsigData: [],
      editorOption: {
        placeholder: "Inserte el texto aquí..",
        modules: {
          toolbar: [
            [{ size: ["small", false, "large", "huge"] }],
            [
              "bold",
              "italic",
              "underline",
              "strike",
              { color: [] },
              { background: [] },
            ],
            [{ align: [] }],
            [
              { list: "ordered" },
              { list: "bullet" },
              { indent: "-1" },
              { indent: "+1" },
            ],
            ["clean"],
          ],
        },
      },
    };
  },
  created() {
  },
  methods: {
    addEvaluators() {
      const { target, prop } = this.$data;

      if (!target[prop]) {
        // target[prop] = [];
        this.$set(target, prop, []);
      }

      if (target[prop].length >= 2) {
        this.$toastr.e(
          this.$t("No puedes agregar más de 3 firmas.")
        );
        return; // Evita agregar más elementos
      }

      target[prop].push({});
    },
    DataSignatures() {
      
      if (this.auxsig.length > 0) {
        for (var i = 0; i < this.auxsig.length; i++) {
          this.addEvaluators();
          this.target[this.prop][i].signature = this.auxsig[i];
        }
      }
    },
    remove(i) {
      const { target, prop } = this.$data;
      if (target[prop]) {
        target[prop].splice(i, 1);
      }
    },
  },
};
</script>
